module.exports = __webpack_public_path__ + "cf3a8a0a66948b3c53e8dc1e099de165.png";